import { render, staticRenderFns } from "./QueryInsured.vue?vue&type=template&id=176ce4da&"
import script from "./QueryInsured.vue?vue&type=script&lang=js&"
export * from "./QueryInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports